module.exports = __webpack_public_path__ + "static/media/clue-2.55e91277.svg";